import {
    format
} from 'date-fns'
import {
    utcToZonedTime, zonedTimeToUtc
} from 'date-fns-tz'

// The Supersheet "Toolkit Webinar Schedule for Homepage" contains date strings in Pacific time.
// This converts it to a formatted date in the user's timezone.
// 'tz' is optional and used for testing, since setting the timezone via jest config didn't work

export const convertAndFormatToUserTimezone = (dateInPacificTZ, tz = null) => {
    const utcDate = zonedTimeToUtc(dateInPacificTZ, 'America/Los_Angeles');
    const userTimeZone = tz ? tz : Intl.DateTimeFormat().resolvedOptions().timeZone;
    const userTimezoneDate = utcToZonedTime(utcDate, userTimeZone);
    const formattedDate = format(userTimezoneDate, 'EEEE, MMMM d, h:mmaaa', { timeZone: userTimeZone });
    const timeZoneName = new Intl.DateTimeFormat('en-US', { timeZone: userTimeZone, timeZoneName: 'short' }).format(userTimezoneDate);
    const timeZoneAbbreviation = timeZoneName.split(' ')[1];

    return `${formattedDate} ${timeZoneAbbreviation}`;
  }